export default __webpack_public_path__ + "static/media/card-banner-budinesscycleNFO.057f333a.png";